export default __webpack_public_path__ + "media/main_banner_mobile_en.5ffdcaf2.png";